<button
  class="rounded"
  matRipple
  [disabled]="disabled"
  (mouseenter)="mouseEnter()"
  (mouseleave)="mouseLeave()"
  [ngClass]="{ 'disabled': disabled, 'highlight': animate || mouseOver &&  !reverseHighlight , 'reverse-highlight': reverseHighlight}">
  <ng-content></ng-content>
</button>
